import type { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import TabContentHeader from '../../components/TabContentHeader.jsx';
import { TabContentProps } from '../../types/singleFlow.js';
import FlowCreation from '../FlowForm/FlowCreation.jsx';

const FlowCreationTab: FC<TabContentProps> = ({ isFlowInUse }) => {
  const { t } = useTranslation('@myn/approval_v2');

  return (
    <div>
      <TabContentHeader title={t('Flow creation')} />
      <div className="mt-4">
        <FlowCreation isFlowInUse={isFlowInUse} />
      </div>
    </div>
  );
};

export default FlowCreationTab;
